import styled, {css} from 'styled-components';
import {Button} from 'antd';

const editButtonStyles = css`
  align-items: center;
  display: flex;
  justify-content: center;

  svg {
    height: ${props => `${props.$iconSize || 24}px`};
    width: ${props => `${props.$iconSize || 24}px`};

    *[fill] {
      fill: ${props => props.color || props.theme.colors.neutral_10};
    }

    *[stroke] {
      stroke: ${props => props.color || props.theme.colors.neutral_10};
    }

    path {
      transition: .2s ease;
    }
  }


  &:not(:disabled):not(.ant-btn-disabled):hover {
    &:hover {
      svg {
        path {
          fill: ${props => props.theme.colors.primary_8};
        }
      }
    }
  }


  &.ant-btn-dangerous {
    &:not(:disabled):not(.ant-btn-disabled):hover {
      &:hover {
        svg {
          path {
            fill: ${props => props.theme.colors.functional_danger};
          }
        }
      }
    }
  }
`;

const StyledEditButton = styled(Button)`
  ${editButtonStyles};
`;

export {
  editButtonStyles,
  StyledEditButton
};
